import axios from "axios";
import config from "../config/config"

const baseURL = axios.create({ baseURL: config.backendBaseUrl });

function setAuthToken(config = null, authToken) {
  const authConfigHeader = { "Authorization": `Bearer ${authToken}` }

  const mergedObj = config || {};
  if (config != null && Object.hasOwn(config, 'headers')) {
    mergedObj.headers = { ...mergedObj.headers, ...authConfigHeader };
  }
  else {
    mergedObj.headers = authConfigHeader;
  }

  return mergedObj;
}

async function post(url, dados = null, authToken = null, config = null) {
    try {
      if(url.includes('admin')){
        if(authToken == null)
          throw new Error('Auth parameter don\'t given') 

        config = setAuthToken(config, authToken)
      }

      if (!url.includes('login') && !url.includes('admin')) {
        const tokenUser = localStorage.getItem('userToken');
        config = setAuthToken(config, tokenUser)
      }
      
      const response = await baseURL.post(url, dados, config);
      return response.data;
    } catch (error) {
        if (error.response) {
          // O servidor respondeu com um status diferente de 2xx
          console.error('Erro na resposta do servidor:', error.response.data);

        if(error.response.status === 400 && 
            error.response.data && 
            error.response.data.Mensagem && 
            error.response.data.Mensagem.includes('Permissão já existente')) {
          // Lançar erro para ser capturado pelo componente apenas nesse erro especifico
          throw error;
        }
        
        // Para outros erros, apenas retornar o erro sem lançar exceção
        return error;

        }else if (error.request) {
          // A requisição foi feita, mas não houve resposta do servidor
          console.error('Sem resposta do servidor:', error.request);
          return error;
        } else {
          // Algo aconteceu na configuração da requisição que causou um erro
          console.error('Erro durante a configuração da requisição:', error.message);
          return error;
        }
        console.error('Erro ao fazer a requisição:', error.config);
    }
}

async function get(url, config = null, authToken = null) {
  try {
    if (url.includes('admin')) {
      if (authToken == null)
        throw new Error('Auth parameter don\'t given')

        config = setAuthToken(config, authToken)
    }

    if (!url.includes('login') && !url.includes('admin')) {
      const tokenUser = localStorage.getItem('userToken');
      config = setAuthToken(config, tokenUser)
    }

    const response = await baseURL.get(url, config);
    return response.data;
  } catch (error) {
    if (error.response) {
      // O servidor respondeu com um status diferente de 2xx
      console.error('Erro na resposta do servidor:', error.response.data);
      return {};
    } else if (error.request) {
      // A requisição foi feita, mas não houve resposta do servidor
      console.error('Sem resposta do servidor:', error.request);
      return {};
    } else {
      // Algo aconteceu na configuração da requisição que causou um erro
      console.error('Erro durante a configuração da requisição:', error.message);
      return {};
    }
    console.error('Erro ao fazer a requisição:', error.config);
  }
}

async function deleteMethod(url, dados = null, authToken = null) {
  try {
    if (url.includes('admin')) {
      if (authToken == null)
        throw new Error('Auth parameter don\'t given')

      dados = setAuthToken(dados, authToken)
    }

    const response = await baseURL.delete(url, dados)
    return response.data;
  } catch (error) {
    if (error.response) {
      // O servidor respondeu com um status diferente de 2xx
      console.error('Erro na resposta do servidor:', error.response.data);
      return {};
    } else if (error.request) {
      // A requisição foi feita, mas não houve resposta do servidor
      console.error('Sem resposta do servidor:', error.request);
      return {};
    } else {
      // Algo aconteceu na configuração da requisição que causou um erro
      console.error('Erro durante a configuração da requisição:', error.message);
      return {};
    }
    console.error('Erro ao fazer a requisição:', error.config);
  }
}

export { post, get, deleteMethod };